import { connect } from 'react-redux';
import { onChange, onChangeItem } from './../../../../../actions/addOrder';
import { keepState } from './../../../../../actions/appAction';
import { searchCountry } from './../../../../../actions/getListCountry';
import { filterItemCode } from './../../../../../actions/getListItemName';
import ModalComponent from './../../../components/modal-component';
import './styles.css';

class Modal extends ModalComponent { }

const mapStateToProps = state => {
    return {
        isDisable: state.addOrder.isDisable,
        confirm_save_order: state.addOrder.confirm_save_order,
        itemOrder: state.addOrder.items,
        order: state.addOrder,
        information: state.addOrder.information,
        classes: state.addOrder.classes,
        listItemName: state.getListItemName,
        itemName: state.getListItemName
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onChange: payload => {
            dispatch(onChange(payload))
        },
        onChangeItem: payload => {
            dispatch(onChangeItem(payload))
        },
        searchCountry: payload => {
            dispatch(searchCountry(payload))
        },
        filterItemCode: payload => {
            dispatch(filterItemCode(payload))
        },
        keepState: payload => {
            dispatch(keepState(payload))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Modal)


// WEBPACK FOOTER //
// ./src/containers/orders/add/components/modal/index.js